import { useEffect, useState } from "react";
import {
  useCreateFPOMutation,
  useGetFPOListQuery,
  useUpdateFPOLeadByIdMutation,
} from "./FPOApiSlice";
import { useGetCBBOListQuery } from "../CBBO/CBBOApiSlice";
import { Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import CustomTable from "components/CustomTable";
import CustomSearchBar from "components/CustomSearchBar";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import CustomTextField from "components/CustomTextField";
import { Input, CardHeader } from "reactstrap";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";
import useDebouncedValue from "hooks/useDebouncedValue";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
const FPOList = () => {
  const { id } = useParams();
  const orgId = id ? id : "";
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [addFPOModel, setFPOAddModel] = useState(false);
  const [password, setPassword] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.groups;
  const Rolerealm_access = currentUser?.realm_access?.roles;
  const [PincodeValue, setPincode] = useState("");
  const [PincodeDataList, setPincodeDataList] = useState([]);
  const [pincodeError, setPinCodeError] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const debouncedSearch = useDebouncedValue(searchKey);
  const [showProject, setShowProject] = useState(false);

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };

  const [FPOData, setFPOData] = useState({
    organization_name: "",
    organization_category: "Farmer Groups",
    organization_type: "FPO",
    organization_sector: "",
    email: "",
    password: "",
    phone_number: "",
    registration_number: "",
    implementation_agency: "",
    land_holding: "",
    income: "",
    pincode: "",
    reporting_organization_id: "",
  });

  const [createFPO] = useCreateFPOMutation();
  const [updateFPOLead] = useUpdateFPOLeadByIdMutation();
  const [fpoid, setFpoId] = useState("");
  const [editApi, setEditSubmitApi] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectUrl, setProjectUrl] = useState("");

  const [CBBOList, setCbboList] = useState([]);
  const { data: data, isLoading, refetch } = useGetFPOListQuery({
    pagination,
    searchKey: debouncedSearch || "",
    orgId,
  });
  const { data: CbboList } = useGetCBBOListQuery({
    pagination: "",
    searchKey: searchKey || "",
  });

  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data?.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
    if (CbboList !== undefined) {
      setCbboList(CbboList?.data?.results);
    }
  }, [data, CbboList]);

  const columns = [
    { field: "organization_name", headerName: "Organization", width: 180 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 120,
      type: "date",
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY "),
    },
    { field: "phone_number", headerName: "Phone Number", width: 140 },
    { field: "email", headerName: "Email", width: 180 },
    { field: "registration_number", headerName: "COI Number", width: 150 },
    {
      field: "implementation_agency",
      headerName: "Implementation Agency",
      width: 200,
    },
    { field: "land_holding", headerName: "Land Holding", width: 130 },

    {
      field: "current_status",
      headerName: "Status",
      width: 170,
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;

        const statusConfig = {
          "LEAD GENERATED": {
            color: "blue",
            icon: <FileTextOutlined />,
          },
          APPROVED: { color: "gold", icon: <CheckCircleOutlined /> },
          REJECTED: { color: "error", icon: <WarningOutlined /> },
          COMPLETED: { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>{status}</span>
          </Tag>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (cellvalues) => {
        return (
          <div>
            <Link to={`/onboarding/farmers-group/FPO/${cellvalues.id}`}>
              <i className="p-2 mdi mdi-eye text-orange fs-5" name={"view"}></i>
            </Link>
            <FontAwesomeIcon
              icon={faPenToSquare}
              className="mx-2 cursor-pointer"
              style={{ color: "orange", fontSize: "16px" }}
              onClick={() => handleAddFpoModel(false, cellvalues?.row)}
            />
          </div>
        );
      },
    },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
  };
  const handleChange = (event) => {
    setFPOData({
      ...FPOData,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (PincodeValue.length === 6) {
        const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (data[0].Status === "Success") {
              setPincodeDataList(data[0].PostOffice[0]);
              setPinCodeError(false);
            } else {
              setPinCodeError(true);
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [PincodeValue]);

  const handleSubmitButton = (e) => {
    e.preventDefault();
    if (PincodeValue) {
      if (PincodeValue?.length < 6) {
        setPinCodeError(true);
        return;
      } else {
        setPinCodeError(false);
      }
    }
    setLoader(true);
    let sendData = {
      organization_name: FPOData.organization_name,
      organization_category: "Farmer Groups",
      organization_type: FPOData.organization_type,
      organization_sector: FPOData.organization_sector,
      email: FPOData.email,
      password: password || FPOData.password,
      phone_number: FPOData.phone_number,
      registration_number: FPOData.registration_number,
      implementation_agency: FPOData.implementation_agency,
      land_holding: FPOData.land_holding,
      income: FPOData.income,
      pincode: PincodeValue,
      reporting_organization_id:
        (RoleAcessParams.includes("admin") ||
          RoleAcessParams.includes("developer")) &&
        (Rolerealm_access.includes("admin") ||
          Rolerealm_access.includes("developer"))
          ? FPOData.reporting_organization_id
          : currentUser.organization_id,
      ...(showProject &&
        projectName && {
          project: {
            project_name: projectName,
          },
        }),
    };
    if (editApi) {
      updateFPOLead({ id: fpoid, payload: sendData })
        .unwrap()
        .then((data) => {
          if (data.success) {
            swal("Fpo Updated Successfully", {
              buttons: false,
              icon: "success",
              title: "FPO Updated",
              timer: 1500,
            });
            setLoader(false);
            setFPOAddModel(false);
            refetch();
            setFPOData({
              organization_name: "",
              organization_category: "Farmer Groups",
              organization_type: "FPO",
              organization_sector: "",
              email: "",
              password: "",
              phone_number: "",
              registration_number: "",
              implementation_agency: "",
              land_holding: "",
              income: "",
              pincode: "",
              reporting_organization_id: "",
            });
            setFpoId("");
          } else {
            swal("Oops", {
              buttons: false,
              icon: "warning",
              title: "Something went wrong !!!",
              timer: 1500,
            });
          }
        });
    } else {
      createFPO(sendData)
        .unwrap()
        .then((data) => {
          if (data.success) {
            swal("Applicant Created Successfully", {
              buttons: false,
              icon: "success",
              title: "Applicant Created Detail",
              timer: 1500,
            });
            setLoader(false);
            setFPOAddModel(false);
            refetch();
            setPincode("");
            setPincodeDataList([]);
            setFPOData({
              organization_name: "",
              organization_category: "Farmer Groups",
              organization_type: "FPO",
              organization_sector: "",
              email: "",
              password: "",
              phone_number: "",
              registration_number: "",
              implementation_agency: "",
              land_holding: "",
              income: "",
              pincode: "",
              reporting_organization_id: "",
            });
            handleClose();
          }
        })
        .catch((data) => {
          if (data.data.error.code == 400) {
            const errorDetails = data.data.error.details;
            let errorMessage = data.data.error.message + "\n";
            if (errorDetails) {
              for (const [key, value] of Object.entries(errorDetails)) {
                errorMessage = `${key}: ${value.join(", ")}\n`;
              }
            }
            swal("!!", {
              buttons: false,
              icon: "warning",
              title: errorMessage,
              timer: 2000,
            });
            setLoader(false);
            return;
          } else if (data.data.error.code == 409) {
            swal("!!", {
              buttons: false,
              icon: "warning",
              title: data.data.error.message,
              timer: 2000,
            });
            setLoader(false);
          }
        });
    }
  };

  const handleAddFpoModel = (addFpo, FpoData) => {
    setFPOAddModel(true);
    if (addFpo) {
      console.log("adding the FPO");
    } else {
      let setDefaultValue = {
        organization_name: FpoData.organization_name,
        organization_category: FpoData.organization_category,
        organization_type: FpoData.organization_type,
        organization_sector: FpoData.organization_sector,
        email: FpoData.email,
        password: FpoData.password,
        phone_number: FpoData.phone_number,
        registration_number: FpoData.registration_number,
        implementation_agency: FpoData.implementation_agency,
        land_holding: FpoData.land_holding,
        income: FpoData.income,
        pincode: FpoData.pincode,
        reporting_organization_id: FpoData.reporting_to?.id,
        reporting_name: FpoData?.reporting_to?.organization_name,
      };
      setPincode(FpoData.pincode);
      setFPOData(setDefaultValue);
      setEditSubmitApi(true);
      setFpoId(FpoData.id);
    }
  };

  const handleClose = () => {
    setFPOAddModel(false);
    setLoader(false);
    setEditSubmitApi(false);
    setFpoId("");
    setFPOData({
      organization_name: "",
      organization_category: "Farmer Groups",
      organization_type: "FPO",
      organization_sector: "",
      email: "",
      password: "",
      phone_number: "",
      registration_number: "",
      implementation_agency: "",
      land_holding: "",
      income: "",
      pincode: "",
      reporting_organization_id: "",
    });
    setPassword("");
    setShowProject(false);
  };

  const handlePinCodeChange = (e) => {
    const newPinCode = e.target.value;
    if (newPinCode.length <= 6) {
      setPincode(newPinCode);
    }
    setHasInteracted(true);
  };

  return (
    <div className="mt-lg-0 mt-md-0 mt-3">
      <CardHeader className="mt-1">
        <div className="d-lg-block d-md-block d-none">
          <Row>
            <Col lg="4" className="d-flex align-items-center">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
            <Col lg="8">
              <div className=" d-flex justify-content-end align-items-center gap-4">
                <div className="">
                  Total :
                  <span className="text-success">
                    &nbsp;{data?.data?.total}
                  </span>
                </div>

                <Button
                  size="sm"
                  className="float-end d-flex align-items-center"
                  onClick={() => handleAddFpoModel(true, null)}
                >
                  <span className="d-lg-block d-none"> Add </span> &nbsp;
                  <i className="mdi mdi-account-plus fs-6 "></i>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </CardHeader>

      <div className="d-lg-none d-md-none d-block mt-1">
        <Row className=" d-flex justify-content-end">
          <div className="d-flex justify-content-between align-items-center">
            <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            <Col md={2}>
              <Button
                className="btn float-end  d-flex"
                onClick={(s) => handleAddFpoModel(true, null)}
              >
                <span className="d-lg-block d-none"> Add FPO </span>{" "}
                <i className="mdi mdi-account-plus fs-6 "></i>
              </Button>
            </Col>
          </div>

          <div className="my-lg-0 my-md-0 my-1">
            {" "}
            Total FPO :
            <span className="text-success">&nbsp;{data?.data?.total}</span>
          </div>
        </Row>
      </div>
      <div className="mt-lg-3 mt-md-3 mt-0">
        <CustomTable
          rows={tableData.rows}
          columns={tableData.columns}
          paginationState={tableData.paginationState}
          loading={tableData.isLoading}
          checkboxShowFalse
        />
      </div>
      <Modal show={addFPOModel} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            Add Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <form onSubmit={(e) => handleSubmitButton(e)}>
            <Row className="text-gray">
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="organization_name"
                  placeholder="Enter name"
                  value={FPOData.organization_name}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col lg="3" className=" mb-2">
                <label className="text-black mb-2">
                  Organization Sector <span className="checkingcss">*</span>
                </label>
                <Input
                  type="select"
                  className="form-control"
                  style={{
                    padding: "9px",
                    borderRadius: "4px",
                    border: "1px solid rgba(151, 151, 151, 0.3)",
                  }}
                  onChange={handleChange}
                  name="organization_sector"
                  value={FPOData.organization_sector}
                  required
                >
                  <option value="">Select Sector</option>
                  <option value="Private"> Private </option>
                  <option value="Government"> Government </option>
                  <option value="NBFC"> NBFC </option>
                  <option value="Societies"> Societies </option>
                  <option value="NGO">NGO </option>
                  <option value="Parternship"> Parternship </option>
                  <option value="Other"> Other </option>
                </Input>
              </Col>

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="email"
                  name="email"
                  placeholder="someone@example.com"
                  required
                  onChange={handleChange}
                  value={FPOData.email}
                />
              </Col>

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="phone_number"
                  placeholder="123456789"
                  minlength="10"
                  maxlength="10"
                  onChange={handleChange}
                  value={FPOData.phone_number}
                  required
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="registration_number"
                  placeholder="COI4321"
                  onChange={handleChange}
                  value={FPOData.registration_number}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="implementation_agency"
                  placeholder="Agency name"
                  onChange={handleChange}
                  value={FPOData.implementation_agency}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="number"
                  name="land_holding"
                  placeholder="1234.."
                  onChange={handleChange}
                  value={FPOData.land_holding}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="number"
                  name="income"
                  placeholder="1234.."
                  onChange={handleChange}
                  value={FPOData.income}
                />
              </Col>

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="number"
                  name="pincode"
                  value={PincodeValue}
                  onChange={handlePinCodeChange}
                  maxLength="6"
                  required
                />
                {hasInteracted && PincodeValue.length !== 6 && (
                  <div style={{ color: "red" }}>
                    Enter a valid 6-digit pincode
                  </div>
                )}
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="State"
                  value={PincodeDataList.State ? PincodeDataList.State : ""}
                  disabled
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="District"
                  value={
                    PincodeDataList.District ? PincodeDataList.District : ""
                  }
                  disabled
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="Block"
                  value={PincodeDataList.Block ? PincodeDataList.Block : ""}
                  disabled
                />
              </Col>
              {/* {console.log("organization",FPOData?.reporting_name)} */}
              {(RoleAcessParams.includes("admin") ||
                RoleAcessParams.includes("developer")) &&
              (Rolerealm_access.includes("admin") ||
                Rolerealm_access.includes("developer")) ? (
                <Col lg="3" className=" mb-2">
                  <label className="text-black mb-2">CBBO</label>
                  <Input
                    type="select"
                    className="form-control "
                    style={{
                      padding: "9px",
                      borderRadius: "4px",
                      border: "1px solid rgba(151, 151, 151, 0.3)",
                    }}
                    onChange={handleChange}
                    name="reporting_organization_id"
                    value={FPOData?.reporting_organization_id}
                  >
                    <option value="">Select CBBO </option>
                    {CBBOList?.map((item) => {
                      return (
                        <option value={item.id}>
                          {" "}
                          {item.organization_name}{" "}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Row className="align-items-center mb-2 mt-2">
              <Col lg="3" className="d-flex align-items-center">
                <Input
                  type="checkbox"
                  id="analytics-checkbox"
                  checked={showProject}
                  onChange={(e) => setShowProject(e.target.checked)}
                  className="me-2"
                />
                <label
                  htmlFor="analytics-checkbox"
                  className="mb-0 fw-semibold"
                >
                  <i className="text-warning">Is it a Project?</i>
                </label>
              </Col>
              {showProject && (
                <Col lg="6">
                  <CustomTextField
                    type="text"
                    name="projectName"
                    label="Project Name"
                    placeholder="Enter project name"
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                    required
                  />
                </Col>
              )}
            </Row>
            <Button
              className={`btn btn-success px-3 `}
              style={{ float: "right" }}
              type="submit"
            >
              Submit &nbsp;{" "}
              {loader ? <Spinner animation="border" size="sm"></Spinner> : ""}
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FPOList;
